module.exports = {
  port: process.env.PORT || 1112,
  pipeline_id: process.env.NEXT_PUBLIC_CI_PIPELINE_ID,
  deployment_env: process.env.NEXT_PUBLIC_CI_ENVIRONMENT_NAME || 'local',
  carbon_app_api_key: process.env.NEXT_PUBLIC_CARBON_APP_API_KEY,
  stripe_api_key: process.env.NEXT_PUBLIC_STRIPE_CLIENT_ID,
  api_url: process.env.NEXT_PUBLIC_API_URL,
  mycc_base_url: process.env.NEXT_PUBLIC_MYCC_BASE_URL,
};
